import React from 'react';
import { strings } from 'src/localization';
import css from './ToastBar.module.scss';
import { IconCheckMark } from 'src/content/icons';
import { SpecData } from 'src/models';
import classNames from 'classnames';

export interface IProps {
    type?: string;
    message: string;
    specialMsg?: string;
    specData?: SpecData;
    theme?: string;
}

const ToastBar = (props: IProps) => {
    let header = strings.ApptSelected;
    let toastClass = css.toastDiv;
    if (props.type === 'Service') {
        header = strings.ServiceAdded;
    }
    if (props.type === 'Recall') {
        header = strings.ServiceAdded;
        if (props.specData?.recallMsg) {
            header = props.specData?.recallMsg;
        }
        toastClass = css.toastDivRecall;
    }
    if (props.type === 'RestrRecall') {
        if (props.specialMsg) {
            header = props.specialMsg;
        }
        toastClass = css.toastDivRecall;
    }

    const toastH2Class = classNames(
        css.toastH2,
        {
            [css.colorIsBackgroundColor]: props.theme === 'ford' || props.theme === 'mercedesBenz',
            [css.fontWeightBaseText]: props.theme === 'ford' || props.theme === 'bmw' ||
            props.theme === 'buick' || props.theme === 'honda' || props.theme === 'infiniti' ||
            props.theme === 'mercedesBenz' || props.theme === 'acura',
            [css.mazdaToastH2]: props.theme === 'mazda', [css.genesisToastH2]: props.theme === 'genesis',
            [css.lexusToastH2]: props.theme === 'lexus',
        },
    );
    const toastH3Class = classNames(
        css.toasth3,
        {
            [css.colorIsBackgroundColor]: props.theme === 'ford' || props.theme === 'mercedesBenz',
            [css.fontWeightBaseText]: props.theme === 'ford' || props.theme === 'honda',
            [css.lexusToastH3]: props.theme === 'lexus',
        },
    );
    const iconBorderClass = classNames(
        css.iconBorder,
        {
            [css.bgColorIsBackgroundColor]: props.theme === 'ford' || props.theme === 'mercedesBenz',
            [css.borderColorToastBg]: props.theme === 'mercedesBenz',
        },
    );
    const mainDivClass = classNames(
        css.mainDiv,
        {
            [css.colorIsBackgroundColor]: props.theme === 'ford',
        },
    );

    const message = props.message;

    return (
        <div className={mainDivClass}>
            <div className={iconBorderClass}>
                <IconCheckMark
                    style={{
                        height: '3.5rem',
                        width: '3.5rem',
                        margin: '-.5rem .5rem 0.5rem',
                    }} />
            </div>

            <div className={toastClass}>
                <h2 id='headerMsg' className={toastH2Class}>{header}</h2>
                <h3 className={toastH3Class}>{message}</h3>
            </div>
        </div>
    );
};

export default ToastBar;